import { connect } from "react-redux";
import ResourceMonitoring from "./resourceMonitoring";
import { createMeetingRequest, updateMeetingRequest, getMeetings, cancelMeetingRequest, deleteMeetingRequest, fetchMeeting } from '../../../store/actions/meetings.actions'
import { getUsers } from '../../../store/actions/user.actions';
import { users } from '../../../store/selectors/user.selector';
import { shifts } from '../../../store/selectors/shift.selector';
import { assignShiftRequest, getShiftsRequest } from '../../../store/actions/shifts.actions';
import { loader } from '../../../store/selectors/shift.selector';

const mapDispatchToProps = { assignShiftRequest, getShiftsRequest, getUsersRequest: getUsers, fetchMeeting, createMeetingRequest, updateMeetingRequest, getMeetings, cancelMeetingRequest, deleteMeetingRequest };

const mapStateToProps = (state) => { 
    const allShifts = shifts(state);
    const loading = loader(state);
    const allUsers = users(state);
    return { allUsers, loading, allShifts };
 };

export default connect(mapStateToProps, mapDispatchToProps)(ResourceMonitoring);